import React from "react";
import { useLoadScript } from "@react-google-maps/api";
import MapWithResults from "./MapComponent";
import Skeleton from "react-loading-skeleton"; // Import Skeleton
import "react-loading-skeleton/dist/skeleton.css"; // Import Skeleton styles

const libraries = ["places"];

const EmplacementEtablissement = (props) => {
    // console.log(props);

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries,
  });

  // Show skeletons while the Google Maps script is loading
  if (!isLoaded) {
    return (
      <div>
        <h3 className="grey500">
          <Skeleton width={200} />
        </h3>
        <p className="body grey66 mt-8">
          <Skeleton width={300} />
        </p>
        <div style={{ height: "300px", marginTop: "20px" }}>
          <Skeleton height="100%" />
        </div>
      </div>
    );
  }

  // When Google Maps is loaded, display actual content
  return (
    <div className="twyny-border-bottom mt-32">
      <h3 className="grey500 mb-0 break-all">{props?.title}</h3>
      <p className="body grey66 mt-8 mb-0">{props?.adr}</p>
      <div className="mt-16">
      <MapWithResults
        data={[{formatted_address:props?.adr,lat:props?.LatLng?.lat,lng:props?.LatLng?.lng}]}
        addressKey={props?.adr}
        isGoogleLoaded={isLoaded}
        single={true}
      />
      </div>
      
    </div>
  );
};

export default EmplacementEtablissement;
